import { ChangeDetectionStrategy, Component } from "@angular/core";
import { FieldType, FormlyModule } from "@ngx-formly/core";
import { Message } from "primeng/message";
import { OverlayBadge } from "primeng/overlaybadge";
import { NewUiCandidateDocumentDateComponent } from "../../features/candidate-document-metadata/metadata-wrapper-components/new-ui-candidate-document-date.component";

@Component({
  selector: "new-ui-formly-document-date",
  templateUrl: "./new-ui-formly-document-date.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FormlyModule, NewUiCandidateDocumentDateComponent, OverlayBadge, Message],
})
export class NewUiFormlyDocumentDateComponent extends FieldType {}
